import './legacy';
import Player from './Player';
import JW8Player from './JW8Player';
import FlowNPlayer from './FlowNPlayer';

/**
 * Creates an AnyPlayer instance from a DOM element container
 *
 * @global
 * @param {string} id
 *   DOM element ID
 * @return {HTMLVideoElement|null}
 *   Video element
 */
const anyplayer = function (id) {
  let element

  if (typeof id === 'string') {
    element = document.getElementById(id)

    if (element === null) {
      throw new DOMException(`Element #${id} not found`)
    }
  } else if (typeof id === 'object') {
    element = id
  } else {
    throw new Error(`Invalid argument ${id}`)
  }

  if (element.hasOwnProperty('_anyplayer')) {
    return element._anyplayer
  }

  let player = null

  if (element.hasOwnProperty('playerType') && element.hasOwnProperty('playerVersion')) {
    return element;
  } else if (JW8Player.handles(element)) {
    if (__DEBUG__) {
      console.info('JW Player detected')
    }
    player = new JW8Player(element)
  } else if (FlowNPlayer.handles(element)) {
    if (__DEBUG__) {
      console.info('Flow player Native detected');
    }
    player = new FlowNPlayer(element);
  } else if (element instanceof HTMLVideoElement) {
    if (__DEBUG__) {
      console.info('HTMLVideoElement detected');
    }
    player = new Player(element);
  } else {
    throw new Error('Unsupported player');
  }

  if (player !== null) {
    player.init()
    element._anyplayer = player.getElement()
    return element._anyplayer
  }

  return null
}

export default anyplayer
